import { render, staticRenderFns } from "./forecast-category.vue?vue&type=template&id=35ba7744&scoped=true"
import script from "./forecast-category.vue?vue&type=script&lang=js"
export * from "./forecast-category.vue?vue&type=script&lang=js"
import style0 from "./forecast-category.vue?vue&type=style&index=0&id=35ba7744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ba7744",
  null
  
)

export default component.exports